const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

const REVERSE: Record<string, number> = Object.fromEntries(
  [...ALPHABET].map((char, index) => [char, index]),
);

/** Encode bytes as unpadded base64url (RFC 4648 §5). */
export function bytesToBase64Url(bytes: Uint8Array): string {
  let output = '';
  let index = 0;

  for (; index + 2 < bytes.length; index += 3) {
    const chunk =
      ((bytes[index] ?? 0) << 16) | ((bytes[index + 1] ?? 0) << 8) | (bytes[index + 2] ?? 0);
    output += ALPHABET[(chunk >> 18) & 63];
    output += ALPHABET[(chunk >> 12) & 63];
    output += ALPHABET[(chunk >> 6) & 63];
    output += ALPHABET[chunk & 63];
  }

  const remaining = bytes.length - index;
  if (remaining === 1) {
    const chunk = (bytes[index] ?? 0) << 16;
    output += ALPHABET[(chunk >> 18) & 63];
    output += ALPHABET[(chunk >> 12) & 63];
  } else if (remaining === 2) {
    const chunk = ((bytes[index] ?? 0) << 16) | ((bytes[index + 1] ?? 0) << 8);
    output += ALPHABET[(chunk >> 18) & 63];
    output += ALPHABET[(chunk >> 12) & 63];
    output += ALPHABET[(chunk >> 6) & 63];
  }

  return output;
}

/** Decode unpadded base64url. Throws on malformed input. */
export function base64UrlToBytes(value: string): Uint8Array {
  const clean = value.replace(/=+$/g, '');
  if (clean.length % 4 === 1) throw new Error('Invalid base64url length');

  const output = new Uint8Array(Math.floor((clean.length * 3) / 4));
  let buffer = 0;
  let bits = 0;
  let offset = 0;

  for (const char of clean) {
    const digit = REVERSE[char];
    if (digit === undefined) throw new Error('Invalid base64url character');
    buffer = (buffer << 6) | digit;
    bits += 6;
    if (bits >= 8) {
      bits -= 8;
      output[offset] = (buffer >> bits) & 0xff;
      offset += 1;
    }
  }

  return output.subarray(0, offset);
}

const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();

export function encodeBase64UrlText(value: string): string {
  return bytesToBase64Url(textEncoder.encode(value));
}

export function decodeBase64UrlText(value: string): string {
  return textDecoder.decode(base64UrlToBytes(value));
}
